import { BlockNoteSchema, defaultBlockSpecs } from '@blocknote/core';

import { databaseEmbedBlock } from './database-embed-block.web';

/**
 * Shared editor schema: the default BlockNote blocks plus our inline
 * `databaseEmbed` block. This MUST be passed to both `useCreateBlockNote` and
 * every `BlockNoteEditor.create` used for sanitizing/validating content,
 * otherwise the sanitizer would silently drop `databaseEmbed` blocks (and the
 * inline database would disappear on load/save).
 */
export const couplespaceSchema = BlockNoteSchema.create({
  blockSpecs: {
    ...defaultBlockSpecs,
    databaseEmbed: databaseEmbedBlock(),
  },
});
